module.exports = __webpack_public_path__ + "fonts/Poppins-Regular.093ee89b.ttf";